import useTableMaps from "@/Components/Tables/useMaps";
import { TableType } from "@/Components/Tables/useTables";
import { guidGenerator } from "@/shared/utils/helpers";
import { useMemo } from "react";
import useMapId from "./useMapId";

const useMap = () => {
  const [mapId, setMapId] = useMapId();
  const [maps, setMaps] = useTableMaps();
  const hasMapChosen = mapId !== "";
  const map = useMemo(() => maps?.find((m) => m.id === mapId), [maps, mapId]);
  const setTables = (tables: TableType[]) => {
    setMaps((current) =>
      current.map((c) => (c.id === mapId ? { ...map, tables } : c))
    );
  };
  const addTable = (table: TableType) =>
    setMaps((current) =>
      current.map((c) =>
        c.id === mapId ? { ...map, tables: [...map.tables, table] } : c
      )
    );

  const updateTable = (table: TableType) =>
    setMaps((current) =>
      current.map((c) =>
        c.id === mapId
          ? {
              ...map,
              tables: map.tables.map((t) => (t.id === table.id ? table : t)),
            }
          : c
      )
    );

  const removeTable = (tableId: string) =>
    setMaps((current) =>
      current.map((c) =>
        c.id === mapId
          ? {
              ...map,
              tables: map.tables.filter((table) => table.id !== tableId),
            }
          : c
      )
    );

  const duplicateTable = (tableId: string, cb: (id: string) => void) =>
    setMaps((current) =>
      current.map((c) => {
        const id = guidGenerator();
        let copiedTable = map.tables.find((table) => table.id === tableId);
        copiedTable = { ...copiedTable, name: `${copiedTable.name} (1)`, id };
        cb(id);
        return c.id === mapId
          ? {
              ...map,
              tables: [...map.tables, copiedTable],
            }
          : c;
      })
    );

  const duplicateMap = () => {
    const id = guidGenerator();
    const copy = { ...map, name: `${map.name} (1)`, id };
    setMaps((m) => [...m, copy]);
    setMapId(id);
  };
  return {
    updateTable,
    setTables,
    map,
    mapId,
    maps,
    setMapId,
    duplicateTable,
    addTable,
    hasMapChosen,
    removeTable,
    duplicateMap,
  };
};

export default useMap;
